// Guards
import authRoutes from "./auth";
import sharedRoutes from "./shared";
import superuserRoutes from "./superuser";
import userRoutes from "./user";
import AuthGuard from "components/guards/AuthGuard";
import GuestGuard from "components/guards/GuestGuard";
import RegularUserGuard from "components/guards/RegularUserGuard";
import SuperUserGuard from "components/guards/SuperUserGuard";
// Layouts
import AuthLayout from "layouts/Auth";
import DashboardLayout from "layouts/Dashboard";
// Common
import Page404 from "pages/auth/Page404";
import { lazy } from "react";

const SubscriptionPendingActivationPage = lazy(() =>
  import("pages/subscriptions/SubscriptionPendingActivationPage")
);
const SubscriptionPendingCancellationPage = lazy(() =>
  import("pages/subscriptions/SubscriptionPendingCancellationPage")
);

const routes = [
  {
    path: "/",
    element: (
      <RegularUserGuard>
        <DashboardLayout />
      </RegularUserGuard>
    ),
    children: userRoutes,
  },
  {
    path: "/",
    element: (
      <RegularUserGuard>
        <AuthLayout />
      </RegularUserGuard>
    ),
    children: [
      {
        path: "plans/pending-activation",
        element: <SubscriptionPendingActivationPage />,
      },
      {
        path: "plans/pending-cancellation",
        element: <SubscriptionPendingCancellationPage />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: sharedRoutes,
  },
  {
    path: "admin",
    element: (
      <SuperUserGuard>
        <DashboardLayout />
      </SuperUserGuard>
    ),
    children: superuserRoutes,
  },
  {
    path: "auth",
    element: (
      <GuestGuard>
        <AuthLayout />
      </GuestGuard>
    ),
    children: authRoutes,
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
